<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav v-if="true">
        <ul class="footer-menu">
          <li>
            <a @click.prevent="$router.go(-1)" href="#">Indietro</a>
          </li>
          <li>
            <router-link :to="{path:'/'}">Home</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; Dinamica s.n.c. 2019
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue